import { createContext, useContext } from "react";
import { MapEditorUIState } from "./MapEditorContext.types";

export const MapEditorUIContext = createContext<MapEditorUIState | null>(null);

export const useMapEditorUI = (): MapEditorUIState => {
  const context = useContext(MapEditorUIContext);
  if (!context) {
    throw new Error("useMapEditorUI must be used within a MapEditorProvider");
  }
  return context;
};
